import React from "react";
import { ThemeProvider } from "styled-components";
import { useApp } from "./contexts/AppContext";
import themeDefault from "theme/default";
import PropTypes from "prop-types";

const WhitelabelThemeProvider = ({ children }) => {
  const { whitelabel } = useApp();

  const theme = {
    ...themeDefault,
    whitelabel,
  };

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

WhitelabelThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WhitelabelThemeProvider;
